var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { api_service } from '../../../api/api_service';
import { api_urls } from '../../../api/api_urls';
import { utility } from '../../../utils';
import constants from '../../../config/constants';
import { ACKNOWLEDGE_CATEGORY, getAssignDocumentTypeName, getDocumentTypeCode } from '../utils/documentTypes';
import { getFilledCustomReasons } from './DocsBackReasonsForm';
import { findStatusReason } from './ReasonsNoticePreview';
export var DOCS_BACK_MISSING_INFO_STATUS_NAME = '56 - Docs Back Missing Info';
export var StatusReasonAction = {
    NEW: 'NEW',
    EXISTING: 'EXISTING',
    DELETED: 'DELETED',
};
var CONTRACT_STATUS_REASON_TYPE = 'CONTRACT_STATUS';
var createdCustomReasonIds = new Map();
var failureMessage = function (error, fallback) { var _a, _b; return ((_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) || (error === null || error === void 0 ? void 0 : error.message) || fallback; };
var pickCreatedId = function (body) {
    var _a, _b, _c, _d, _e, _f;
    var candidates = [body === null || body === void 0 ? void 0 : body.data, (_a = body === null || body === void 0 ? void 0 : body.data) === null || _a === void 0 ? void 0 : _a.data, (_b = body === null || body === void 0 ? void 0 : body.data) === null || _b === void 0 ? void 0 : _b.Reason, body];
    for (var _i = 0, candidates_1 = candidates; _i < candidates_1.length; _i++) {
        var candidate = candidates_1[_i];
        var id = (_f = (_e = (_d = (_c = candidate === null || candidate === void 0 ? void 0 : candidate.Id) !== null && _c !== void 0 ? _c : candidate === null || candidate === void 0 ? void 0 : candidate.OId) !== null && _d !== void 0 ? _d : candidate === null || candidate === void 0 ? void 0 : candidate.StatusReasonOId) !== null && _e !== void 0 ? _e : candidate === null || candidate === void 0 ? void 0 : candidate.ReasonId) !== null && _f !== void 0 ? _f : candidate === null || candidate === void 0 ? void 0 : candidate.id;
        if (id !== undefined && id !== null && String(id) !== '')
            return String(id);
    }
    return undefined;
};
var createCustomReason = function (category, text) { return __awaiter(void 0, void 0, void 0, function () {
    var documentTypeCode, res, id, created;
    var _a, _b, _c, _d, _e;
    return __generator(this, function (_f) {
        switch (_f.label) {
            case 0:
                documentTypeCode = category === ACKNOWLEDGE_CATEGORY ? undefined : getDocumentTypeCode(category);
                return [4, api_service.post({
                        endPoint: api_urls.CREATE_STATUS_REASON,
                        payLoad: __assign({ ReasonType: CONTRACT_STATUS_REASON_TYPE, Reason: text, IsCustom: 1 }, (documentTypeCode !== undefined ? { DocumentType: documentTypeCode } : {})),
                        showLoader: false,
                    })];
            case 1:
                res = _f.sent();
                if (((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.statusCode) !== undefined && res.data.statusCode !== 200) {
                    throw new Error(((_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.message) || 'Unable to add the custom reason.');
                }
                id = pickCreatedId(res === null || res === void 0 ? void 0 : res.data);
                if (!id)
                    throw new Error('The custom reason was added but its id was not returned.');
                created = [(_c = res === null || res === void 0 ? void 0 : res.data) === null || _c === void 0 ? void 0 : _c.data, (_e = (_d = res === null || res === void 0 ? void 0 : res.data) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.data, res === null || res === void 0 ? void 0 : res.data].find(function (candidate) { return candidate === null || candidate === void 0 ? void 0 : candidate.ActionType; });
                return [2, { id: id, actionType: (created === null || created === void 0 ? void 0 : created.ActionType) ? String(created.ActionType) : undefined }];
        }
    });
}); };
export var saveContractReasons = function (_a) {
    var contractAspireId = _a.contractAspireId, txAspireOId = _a.txAspireOId, status = _a.status, predefinedReasons = _a.predefinedReasons, value = _a.value, _b = _a.existingReasons, existingReasons = _b === void 0 ? [] : _b;
    return __awaiter(void 0, void 0, void 0, function () {
        var custom, _i, _c, reason, key, created, documentType, toAssignedReason_1, existingInList_1, existing_1, deleted_1, added, reasons, res, error_1;
        var _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    if (String(status !== null && status !== void 0 ? status : '').trim() !== DOCS_BACK_MISSING_INFO_STATUS_NAME)
                        return [2, true];
                    if (!contractAspireId) {
                        utility.alert('Unable to save the reasons: the contract id is missing.', constants.TOAST_TYPES.ERROR);
                        return [2, false];
                    }
                    _f.label = 1;
                case 1:
                    _f.trys.push([1, 8, , 9]);
                    custom = [];
                    _i = 0, _c = getFilledCustomReasons(value);
                    _f.label = 2;
                case 2:
                    if (!(_i < _c.length)) return [3, 6];
                    reason = _c[_i];
                    key = "".concat(contractAspireId, "|").concat(reason.category, "|").concat(reason.text);
                    created = createdCustomReasonIds.get(key);
                    if (!!created) return [3, 4];
                    return [4, createCustomReason(reason.category, reason.text)];
                case 3:
                    created = _f.sent();
                    createdCustomReasonIds.set(key, created);
                    _f.label = 4;
                case 4:
                    if (reason.category === ACKNOWLEDGE_CATEGORY && !created.actionType) {
                        throw new Error('The Acknowledge reason was added but the response had no ActionType.');
                    }
                    documentType = reason.category === ACKNOWLEDGE_CATEGORY
                        ? created.actionType
                        : getAssignDocumentTypeName(getDocumentTypeCode(reason.category));
                    custom.push(__assign(__assign({ LookupId: created.id, Reason: reason.text }, (documentType ? { DocumentType: documentType } : {})), { Action: StatusReasonAction.NEW }));
                    _f.label = 5;
                case 5:
                    _i++;
                    return [3, 2];
                case 6:
                    toAssignedReason_1 = function (reason, action) {
                        var documentType = reason.actionType && reason.actionType.toUpperCase() === 'NON_ACTIONABLE'
                            ? reason.actionType
                            : getAssignDocumentTypeName(reason.documentTypeCode);
                        return __assign(__assign({ LookupId: reason.id, Reason: reason.label }, (documentType ? { DocumentType: documentType } : {})), { Action: action });
                    };
                    existingInList_1 = new Set();
                    existing_1 = [];
                    deleted_1 = [];
                    existingReasons.forEach(function (reason) {
                        var match = findStatusReason(reason, predefinedReasons);
                        if (!match) {
                            if (reason.lookupId)
                                existing_1.push({ LookupId: reason.lookupId, Reason: reason.text, Action: StatusReasonAction.EXISTING });
                            return;
                        }
                        if (existingInList_1.has(match.id))
                            return;
                        existingInList_1.add(match.id);
                        var stillSelected = value.selectedIds.includes(match.id);
                        (stillSelected ? existing_1 : deleted_1).push(toAssignedReason_1(match, stillSelected ? StatusReasonAction.EXISTING : StatusReasonAction.DELETED));
                    });
                    added = predefinedReasons
                        .filter(function (reason) { return value.selectedIds.includes(reason.id) && !existingInList_1.has(reason.id); })
                        .map(function (reason) { return toAssignedReason_1(reason, StatusReasonAction.NEW); });
                    reasons = __spreadArray(__spreadArray(__spreadArray(__spreadArray([], existing_1, true), added, true), custom, true), deleted_1, true);
                    if (reasons.length === 0)
                        return [2, true];
                    return [4, api_service.post({
                            endPoint: api_urls.ASSIGN_STATUS_REASONS,
                            payLoad: { TxAspireOId: txAspireOId, ContractAspireId: contractAspireId, Reasons: reasons },
                            showLoader: false,
                        })];
                case 7:
                    res = _f.sent();
                    if (((_d = res === null || res === void 0 ? void 0 : res.data) === null || _d === void 0 ? void 0 : _d.statusCode) !== undefined && res.data.statusCode !== 200) {
                        utility.alert(((_e = res === null || res === void 0 ? void 0 : res.data) === null || _e === void 0 ? void 0 : _e.message) || 'Unable to save the reasons.', constants.TOAST_TYPES.ERROR);
                        return [2, false];
                    }
                    return [2, true];
                case 8:
                    error_1 = _f.sent();
                    utility.alert(failureMessage(error_1, 'Unable to save the reasons.'), constants.TOAST_TYPES.ERROR);
                    return [2, false];
                case 9: return [2];
            }
        });
    });
};
